var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 158,
    viewBox: "0 0 159 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.41064,
    y: 1.3916,
    width: 156,
    height: 155,
    rx: 73,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.163 63.3283L88.6153 48.0586C88.1818 47.6329 87.5966 47.3916 86.9825 47.3916H56.2923C55.0136 47.3916 53.9805 48.4063 53.9805 49.6622V108.698C53.9805 109.954 55.0136 110.968 56.2923 110.968H102.53C103.809 110.968 104.842 109.954 104.842 108.698V64.939C104.842 64.3359 104.596 63.7541 104.163 63.3283ZM99.51 65.9821H85.9133V52.6282L99.51 65.9821ZM99.6401 105.859H59.1822V52.5004H81.0005V67.827C81.0005 68.6173 81.3202 69.3754 81.8893 69.9342C82.4583 70.4931 83.2301 70.8071 84.0349 70.8071H99.6401V105.859ZM78.8332 86.7013H65.5399C65.222 86.7013 64.9619 86.9567 64.9619 87.2689V90.6748C64.9619 90.987 65.222 91.2425 65.5399 91.2425H78.8332C79.151 91.2425 79.4111 90.987 79.4111 90.6748V87.2689C79.4111 86.9567 79.151 86.7013 78.8332 86.7013ZM64.9619 77.6189V81.0248C64.9619 81.337 65.222 81.5924 65.5399 81.5924H93.2824C93.6003 81.5924 93.8604 81.337 93.8604 81.0248V77.6189C93.8604 77.3067 93.6003 77.0512 93.2824 77.0512H65.5399C65.222 77.0512 64.9619 77.3067 64.9619 77.6189Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc2);
export default __webpack_public_path__ + "static/media/doc2.edef5a6f161ee544a8bc29425cdef11e.svg";
export { ForwardRef as ReactComponent };